import React from 'react';
import { Button, Form } from 'react-bootstrap';

export default function ToolingMasterDataPagination({
    rowsPerPage,
    rowCount,
    currentPage,
    onChangePage,
    onChangeRowsPerPage,
}) {
    const pages = Math.max(1, Math.ceil(rowCount / rowsPerPage));

    return (
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-3">
            <Form.Group controlId="tooling-rows-per-page" className="d-flex align-items-center gap-2">
                <Form.Label className="mb-0 text-nowrap">Rows per page</Form.Label>
                <Form.Select
                    className="w-auto"
                    value={rowsPerPage}
                    onChange={(event) =>
                        onChangeRowsPerPage(Number(event.target.value), currentPage)
                    }
                >
                    {[10, 15, 20, 25, 30].map((size) => (
                        <option key={size} value={size}>
                            {size}
                        </option>
                    ))}
                </Form.Select>
            </Form.Group>
            <div className="d-flex align-items-center gap-2">
                <Button
                    variant="outline-secondary"
                    disabled={currentPage <= 1}
                    onClick={() => onChangePage(currentPage - 1, rowCount)}
                >
                    Previous
                </Button>
                <span>Page {currentPage} of {pages}</span>
                <Button
                    variant="outline-secondary"
                    disabled={currentPage >= pages}
                    onClick={() => onChangePage(currentPage + 1, rowCount)}
                >
                    Next
                </Button>
            </div>
        </div>
    );
}
